import React from 'react';
import { ReasonSelectionModal } from './ReasonSelectionModal';

const RescheduleReasonModal = (props) => {
  return <ReasonSelectionModal {...props} reasonType="reschedule" />;
};

export { RescheduleReasonModal };
